import { render } from "./HvanchFeedback.vue?vue&type=template&id=67d6162d&scoped=true"
import script from "./HvanchFeedback.vue?vue&type=script&lang=js"
export * from "./HvanchFeedback.vue?vue&type=script&lang=js"

import "./HvanchFeedback.vue?vue&type=style&index=0&id=67d6162d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d6162d"]])

export default __exports__